import { type PatientTabsCellType } from '@doxyme/ui/components/patterns';
import { createSlice, type Draft, type PayloadAction } from '@reduxjs/toolkit';

type DashboardUIState = {
  isPatientQueueOpen: boolean;
  /**
   * Map of participantId -> currently active tab for that participant.
   * - Keys are participant IDs (string).
   * - Values are PatientTabsCellType when a tab is open, or undefined when closed.
   * - Initialized as an empty object.
   */
  activeTabRecord: Record<string, PatientTabsCellType | undefined>;
  openCellId: string | undefined;
};

const getInitialState = (): DashboardUIState => ({
  isPatientQueueOpen: false,
  activeTabRecord: {},
  openCellId: undefined,
});

export const dashboardUISlice = createSlice({
  name: 'dashboardUI',
  initialState: () => getInitialState(),
  reducers: {
    setIsPatientQueueOpen: (
      state: Draft<DashboardUIState>,
      action: PayloadAction<boolean>,
    ): void => {
      state.isPatientQueueOpen = action.payload;
    },
    setOpenCellId: (
      state: Draft<DashboardUIState>,
      action: PayloadAction<string | undefined>,
    ): void => {
      state.openCellId = action.payload;
    },
    setActiveTabRecord: (
      state: Draft<DashboardUIState>,
      action: PayloadAction<{
        participantId: string;
        tab: PatientTabsCellType | undefined;
      }>,
    ): void => {
      const { participantId, tab } = action.payload;
      state.activeTabRecord[participantId] = tab;
    },
  },
});

export const { setIsPatientQueueOpen, setActiveTabRecord, setOpenCellId } =
  dashboardUISlice.actions;
